import React from 'react'

import { useHasMounted } from '../../hooks/useHasMounted'

import Select, {
  components,
  DropdownIndicatorProps,
  StylesConfig,
  ActionMeta,
} from 'react-select'

import { useIsMobile } from '../../hooks/useIsDesktop'
import variables from '../../styles/_constants.module.scss'

import style from './CustomSelect.module.scss'

export const DropdownIndicator = (props: DropdownIndicatorProps) => {
  return (
    <components.DropdownIndicator {...props}>
      <span className={style.dropdownIndicator}></span>
    </components.DropdownIndicator>
  )
}

export type Value = {
  label: string
  value: string
  required?: boolean
}

export type CustomSelectProps = {
  id: string
  value?: Value
  onChange: (newValue: Value) => void
  options: readonly Value[]
  placeholder?: string
  name?: string
  placeholderColor?: string
}

const CustomSelect = (props: CustomSelectProps) => {
  const hasMounted = useHasMounted()
  const isMobile = useIsMobile()

  if (!hasMounted) {
    return null
  }

  const selectStyles: StylesConfig = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'transparent',
      outline: 'none',
      border: 'none',
      boxShadow: 'none',
      cursor: 'pointer',
      minHeight: 'unset',
    }),
    option: (styles, state: any) => {
      return {
        ...styles,
        backgroundColor: state.isDisabled
          ? undefined
          : state.isSelected
          ? 'none'
          : state.isFocused
          ? 'none'
          : undefined,
        color: state.isDisabled
          ? variables.greyDark
          : state.isFocused
          ? variables.black
          : state.isSelected
          ? variables.grey
          : variables.black,
        cursor: state.isDisabled ? 'not-allowed' : 'pointer',

        ':active': {
          ...styles[':active'],
          backgroundColor: !state.isDisabled
            ? state.isSelected
              ? variables.black
              : variables.greyDark
            : undefined,
          border: 'none',
        },
      }
    },
    container: (styles) => ({
      ...styles,
      minWidth: '22rem',
      flexBasis: isMobile ? '100%' : 'unset',
      margin: '0',
      // height: '1em'
      // backgroundColor: variables.greyLighter,
      // padding: '0 0.25rem'
    }),
    valueContainer: (styles) => ({
      ...styles,
      padding: 0,
      alignItems: 'end',
    }),
    indicatorsContainer: (styles) => ({
      ...styles,
      alignItems: 'flex-end',
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: 'none',
    }),
    input: (styles) => ({
      ...styles,
      padding: isMobile ? 0 : styles.padding,
      margin: isMobile ? 0 : styles.margin,
    }),
    placeholder: (styles) => ({
      ...styles,
      color: props.placeholderColor
        ? props.placeholderColor
        : variables.greyDark,
      marginLeft: '0px',
    }),
    singleValue: (styles, state: any) => ({
      ...styles,
      color: state.data.value != 0 ? variables.black : variables.greyDark,
      marginLeft: '0px',
    }),
  }

  const handleChange = (
    newValue: unknown | null,
    actionMeta: ActionMeta<unknown>
  ) => {
    props.onChange(newValue as Value)
  }

  return (
    <Select
      key="custom-select"
      id={props.id}
      instanceId={props.id + '-instance'}
      options={props.options}
      isSearchable={false}
      value={props.value}
      onChange={handleChange}
      components={{ DropdownIndicator }}
      styles={selectStyles}
      placeholder={props.placeholder}
      name={props.name}
    />
  )
}

export default CustomSelect
